import { createContext, PropsWithChildren, useContext } from 'react'

import { usePLPageMeta } from '@src/components/pl-page-context'
import { useCLPFilters } from '@src/pages/clp1/hooks/use-clp-filters'

import type { SeoData } from '@lastbrand/storefront-proto-registry/api/v1/seo'

// Derived from useCLPFilters so the shape stays in sync automatically.
export type FilterSortContextValue = ReturnType<typeof useCLPFilters>

const FilterSortContext = createContext<FilterSortContextValue | null>(null)

interface FilterSortProviderProps {
  onSeoDataUpdate?: (seoData: SeoData | undefined) => void
}

// Single useCLPFilters instance for the page. Must live inside PLPageProvider.
export function FilterSortProvider({ children, onSeoDataUpdate }: PropsWithChildren<FilterSortProviderProps>) {
  const { pageMetaData } = usePLPageMeta()
  const filterSort = useCLPFilters({
    pageMetaData: pageMetaData as { title: string; slug: string },
    onSeoDataUpdate,
  })
  return <FilterSortContext.Provider value={filterSort}>{children}</FilterSortContext.Provider>
}

export function useFilterSortContext(): FilterSortContextValue {
  const ctx = useContext(FilterSortContext)
  if (!ctx) {
    throw new Error('useFilterSortContext must be used within a FilterSortProvider')
  }
  return ctx
}
